import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export var redirectToApp = (eventLocation, realEstateId) => {
  var _a;
  if (realEstateId) {
    // eslint-disable-next-line max-len
    window.location.replace("https://wikicasa.go.link/annuncio/".concat(realEstateId, "?utm_source=Organic&utm_medium=Pulsante%20sul%20Sito&utm_campaign=annuncio%20singolo&adj_t=1hlanbne&adj_deep_link=wikicasa.adjust%3A%2F%2Fwww.wikicasa.it%2Fannuncio%2F").concat(realEstateId, "%3Futm_source%3DOrganic%26utm_medium%3DPulsante%20sul%20Sito%26utm_campaign%3Dannuncio%20singolo&adj_fallback=https%3A%2F%2Fwww.wikicasa.it%2Fannuncio%2F").concat(realEstateId, "&adj_redirect_macos=https%3A%2F%2Fwww.wikicasa.it%2Fannuncio%2F").concat(realEstateId));
  } else {
    // eslint-disable-next-line max-len
    window.location.replace("https://wikicasa.go.link?adj_t=1j51c0c3&adj_deep_link=wikicasa.adjust%3A%2F%2Fwww.wikicasa.it%2F%3Futm_source%3DOrganic%26utm_medium%3DPulsante%20sul%20Sito%26utm_campaign%3Dlistato&adj_fallback=https%3A%2F%2Fwww.wikicasa.it%2F&adj_redirect_macos=https%3A%2F%2Fwww.wikicasa.it%2F");
  }
  /*if (window.navigator.userAgent.includes("iPhone")) {
      //firefox on ios can't open the app
      if (!window.navigator.userAgent.match(/firefox|fxios/i))
          window.location.replace("wikicasa://");
       setTimeout(() => {
          window.location.replace(
              "https://apps.apple.com/it/app/wikicasa/id1626038379"
          );
      }, 500);
  } else if (window.navigator.userAgent.includes("Android")) {
      const url = "intent://wikicasa.it/#Intent;scheme=https;package=it.wikicasa.wikicasa_app;end";
      window.location.replace(url);
  }*/
  //@ts-ignore
  window.dataLayer.push({
    //GA4
    "event_name": "open_store",
    "event_location": eventLocation,
    "OS": (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent
  });
};